import React from 'react';
import '../../../dmView/style/App.css';
import Icon from '../Icon';

const defaultPlayerOptions = {
    showBlood: true,
    showDead: true,
    showHp: true,
    showHpBar: false
}

const WhoAreYouIcon = ({creature, handleSetSelectedCharacter}) => {

    let name;
    let lastName;

    [name, ...lastName] = creature.name.split(' ');
    lastName = lastName.join(' ') || '';

    return (
            <div style={{cursor: 'pointer'}} onClick={() => handleSetSelectedCharacter(creature)} >
                <Icon key={creature.creatureGuid} isTurn={false} creature={creature} iconOptions={defaultPlayerOptions} iconSize={{width: 200, height: 240}}/>
            </div>
        );
};

export default WhoAreYouIcon;